import "core-js/modules/es.array.index-of";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { HttpMethod } from '@oh-auth/common';
import { AppDto, TokenName } from '@oh-auth/dto';
export var appsApiDefinition = {
  createApp: {
    method: HttpMethod.POST,
    path: 'apps',
    tokenName: TokenName.ACCESS_TOKEN,
    returnType: AppDto,
    prepare: (context, dto) => ({
      body: dto
    })
  },
  createAppAppSecret: {
    method: HttpMethod.POST,
    path: 'apps/:app_id/app_secret',
    tokenName: TokenName.ACCESS_TOKEN,
    returnType: AppDto,
    prepare: (context, dto) => ({
      params: dto
    })
  },
  readApps: {
    method: HttpMethod.GET,
    path: 'apps',
    tokenName: TokenName.ACCESS_TOKEN,
    returnType: [AppDto],
    prepare: context => ({})
  },
  readApp: {
    method: HttpMethod.GET,
    path: 'apps/:app_id',
    tokenName: TokenName.ACCESS_TOKEN,
    returnType: AppDto,
    prepare: (context, dto) => ({
      params: dto
    })
  },
  updateApp: {
    method: HttpMethod.PUT,
    path: 'apps/:app_id',
    tokenName: TokenName.ACCESS_TOKEN,
    returnType: AppDto,
    prepare: (context, dto) => {
      var {
        app_id
      } = dto,
          restDto = _objectWithoutProperties(dto, ["app_id"]);

      return {
        params: {
          app_id
        },
        body: restDto
      };
    }
  },
  deleteApp: {
    method: HttpMethod.DELETE,
    path: 'apps/:app_id',
    tokenName: TokenName.ACCESS_TOKEN,
    returnType: AppDto,
    prepare: (context, dto) => ({
      params: dto
    })
  }
};